import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import './Back.css';

/* Back arrow.

   ★ History first, always. Wherever the visitor came from IS the answer, and a fixed parent is a
   guess that is right for one caller and wrong for the rest — the event editor is opened from the
   programme, from the programme list, from "Events I'm hosting" and from the public page, and the
   run screen from as many again, so a pinned destination made the arrow a sideways step to a
   screen they had never been on rather than a way back.

   `to` is the FALLBACK, for the cold open: a mail link, a bookmark, a shared URL, where stepping
   back leaves the app entirely. React Router keeps its own counter of client-side navigations in
   `history.state.idx`, which is 0 exactly then — one navigation in and it is safe to step back. */
/* `onBack` is for a screen that goes back WITHIN itself — a detail view held in state rather
   than in the URL, where history knows nothing of the step the visitor just took and stepping back
   would leave the screen entirely. When it is given it wins; everything else keeps the history
   behaviour above. */
/* Where it SITS and why it is a disc rather than a bare arrow is in Back.css — short version: out
   of flow so no screen has to make room for it, on its own layer so no screen can bury it. */
const Back = ({ to, onBack, className = '' }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const cameFromInside = (window.history.state?.idx || 0) > 0;

  return (
    <div className={`back-slot ${className}`}>
      <button
        type='button'
        className='back-btn'
        aria-label={t('back')}
        onClick={() => {
          if (onBack) { onBack(); return; }
          return (to && !cameFromInside) ? navigate(to) : navigate(-1);
        }}
      >
        <Icon name='angle-left' />
      </button>
    </div>
  );
};

export default Back;
